<template>
    <div id="wrapper" class="page">
        <Director-Bar index="2"></Director-Bar>
        <div id="content-wrapper">
            <div class="container-fluid">
                <!-- <b-link href="#" @click.prevent="openModal">
            <i class="fas fa-plus mr-2"></i> Thêm
          </b-link>-->
                <div class="row" style="margin-left:1px; height: 45px;">
                    <button class="btn btn-info mb-2 mr-2" @click.prevent="openModal">
                        <i class="fas fa-plus"></i> Add
                    </button>
                    <b-form-group class="mb-2 mr-2">
                        <vue-datepicker-local style="width: 100%" v-model="filterMonth" :local="local" clearable
                            format="MM-YYYY" @input="onfilter" @clear="onfilter" />
                    </b-form-group>
                </div>
                <b-table bordered head-variant="dark" hover responsive striped small table-variant="light" :fields="fields"
                    :items="items">

                    <template v-slot:cell(revenueFrom)="data">
                        {{ data.item.revenueFrom | numeral('0,0') }}
                    </template>
                    <template v-slot:cell(revenueTo)="data">
                        {{ data.item.revenueTo | numeral('0,0') }}
                    </template>
                    <template #cell(to)="data">
                        {{ convertToMMYYYY(convertDate(data.item.to)) }}
                    </template>
                    <template #cell(from)="data">
                        {{ convertToMMYYYY(convertDate(data.item.from)) }}
                    </template>
                    <template v-slot:cell(action)="data">
                        <b-link class="text-primary mr-2" href="#" @click.prevent="openUpdateModal(data)">
                            <i class="fas fa-pencil-alt"></i>
                        </b-link>
                        <b-link class="text-danger" href="#" @click.prevent="deleteItem(data)">
                            <i class="fas fa-trash"></i>
                        </b-link>
                        <!-- <button class="btn btn-info mr-1" @click="openUpdateModal(data)" v-if="meeting_udpate">
                <i class="fas fa-pencil-alt"></i>
              </button>
              <button class="btn btn-danger" @click="deleteItem(data)" v-if="meeting_delete">
                <i class="fas fa-trash-alt"></i>
              </button>             -->
                    </template>
                </b-table>
            </div>
        </div>
        <b-modal v-model="modalShow" @ok="storeItem" header-bg-variant="info" header-text-variant="light">
            <template v-slot:modal-title>
                <div v-if="item.id <= 0">Add </div>
                <div v-else>Update </div>
            </template>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="info" @click="ok()"><i class="fas fa-save mr-2"></i>Save</b-button>
                <b-button variant="secondary" @click="cancel()"><i class="fas fa-times mr-2"></i>Close</b-button>
            </template>
            <b-container>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label> Revenue From - To <code>*</code> </template>
                            <template>
                                <b-row>
                                    <b-col>
                                        <!-- <b-form-input size="md" list="my-list-id" v-model="pitch.BudgetRange" placeholder="Please write the budget range (as per your knowledge)" number="true" required></b-form-input> -->
                                        <my-currency-input v-model="item.revenueFrom" />
                                    </b-col>
                                    <b-col>
                                        <!-- <b-form-input size="md" list="my-list-id" v-model="pitch.BudgetRange" placeholder="Please write the budget range (as per your knowledge)" number="true" required></b-form-input> -->
                                        <my-currency-input v-model="item.revenueTo" />
                                    </b-col>
                                    <p class="mt-2 mr-3">VND</p>
                                </b-row>
                            </template>
                        </b-form-group>
                    </b-col>

                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label> Gross Profit From - To <code>*</code> </template>
                            <template>
                                <b-row>
                                    <b-col>
                                        <!-- <b-form-input size="md" list="my-list-id" v-model="pitch.BudgetRange" placeholder="Please write the budget range (as per your knowledge)" number="true" required></b-form-input> -->
                                        <b-form-input style="text-align: right;" v-model="item.grossFrom"
                                            id="textarea-auto-height" placeholder="" type="number">
                                        </b-form-input>
                                    </b-col>
                                    <b-col>
                                        <!-- <b-form-input size="md" list="my-list-id" v-model="pitch.BudgetRange" placeholder="Please write the budget range (as per your knowledge)" number="true" required></b-form-input> -->
                                        <b-form-input style="text-align: right;" v-model="item.grossTo"
                                            id="textarea-auto-height" placeholder="" type="number">
                                        </b-form-input>
                                    </b-col>
                                    <p class="mt-2 mr-3">%</p>
                                </b-row>
                            </template>
                        </b-form-group>
                    </b-col>

                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Bonus per Job
                                <span class="text-danger">*</span>
                            </template>
                            <b-form-input style="text-align: right;" v-model="item.percent" id="textarea-auto-height"
                                placeholder="" type="number">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label> Effective date From - To <code>*</code> </template>
                            <template>
                                <b-row>
                                    <b-col>
                                        <!-- <b-form-input size="md" list="my-list-id" v-model="pitch.BudgetRange" placeholder="Please write the budget range (as per your knowledge)" number="true" required></b-form-input> -->
                                        <vue-datepicker-local style="width: 100%" v-model="item.from" :local="local"
                                            clearable format="MM-YYYY" />
                                    </b-col>
                                    <b-col>
                                        <!-- <b-form-input size="md" list="my-list-id" v-model="pitch.BudgetRange" placeholder="Please write the budget range (as per your knowledge)" number="true" required></b-form-input> -->
                                        <vue-datepicker-local style="width: 100%" v-model="item.to" :local="local" clearable
                                            format="MM-YYYY" />
                                    </b-col>

                                </b-row>
                            </template>
                        </b-form-group>
                    </b-col>

                </b-row>

            </b-container>
        </b-modal>
    </div>
</template>
  
<script>
import axios from "axios";
import DirectorBar from "../Bonus/Bonus_Bar.vue";

import MyCurrencyInput from "../../components/App/MyCurrencyInput.vue";
// Import the styles too, globally
import VueDatepickerLocal from "vue-datepicker-local";
import "vue-swatches/dist/vue-swatches.css";
export default {
    name: "Meetings",
    components: {
        DirectorBar,
        VueDatepickerLocal,
        MyCurrencyInput
    },
    data() {
        return {
            fields: [
                {
                    key: "revenueFrom",
                    label: "Revenue From >=",
                },
                {
                    key: "revenueTo",
                    label: "Revenue To <=",
                },
                {
                    key: "grossFrom",
                    label: "Gross Profit From >=",
                },
                {
                    key: "grossTo",
                    label: "Gross Profit To <",
                },
                {
                    key: "percent",
                    label: "Bonus per Job",
                },
                {
                    key: "from",
                    label: "Effective date",

                },
                {
                    key: "to",
                    label: "Expiration date",

                },
                {
                    key: "action",
                    label: "",
                    thStyle: { width: "50px !important" },
                },
            ],
            local: {
                monthsHead: "January_February_March_April_May_June_July_August_September_October_November_December".split(
                    "_"
                ), // months of head
                months: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split(
                    "_"
                ), // months of panel
                weeks: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), // weeks,
            },
            items: [],
            itemsOriginal: [],
            filterMonth: null,
            item_null: {
                id: 0,
                revenueFrom: 0,
                revenueTo: 0,
                grossFrom: 0,
                grossTo: 0,
                percent: 0,
                to: null,
                from: null,
            },
            item: {
                id: 0,
                revenueFrom: 0,
                revenueTo: 0,
                grossFrom: 0,
                grossTo: 0,
                percent: 0,
                to: null,
                from: null,
            },
            modalShow: false,
            url: "/api/Bonus/storeBonusRate",
        };
    },
    computed: {

    },
    beforeRouteEnter(to, from, next) {
        axios
            .get("/api/Bonus/getBonusRate")
            .then((response) => {
                next((vm) => vm.initData(response.data));
            })
            .catch((err) => {
                next();
            });
    },
    methods: {
        initData(data) {
            this.items = data;
            this.itemsOriginal = data;
            this.filterMonth = new Date();
            this.onfilter();
        },
        onfilter() {
            //this.$log("testsssss filter" + this.filterMonth);
            this.items = this.itemsOriginal.filter(x => {
                // Convert x.from and x.to to Date objects if they are not already
                const fromDate = x.from instanceof Date ? x.from : new Date(x.from);
                const toDate = x.to instanceof Date ? x.to : new Date(x.to);
                if (!this.filterMonth) {
                    return true; // Include all elements
                }
                const filterMonthYear = this.filterMonth.getFullYear();
                const filterMonthMonth = this.filterMonth.getMonth();
                const fromYear = fromDate.getFullYear();
                const fromMonth = fromDate.getMonth();
                const toYear = toDate.getFullYear();
                const toMonth = toDate.getMonth();
                return ((filterMonthYear > fromYear || (filterMonthYear === fromYear && filterMonthMonth >= fromMonth)) &&
                    (filterMonthYear < toYear || (filterMonthYear === toYear && filterMonthMonth <= toMonth)));
            });
        },
        openModal() {
            this.item = JSON.parse(JSON.stringify(this.item_null));
            this.modalShow = true;
        },
        openUpdateModal(data) {
            this.$log(data);
            this.item = JSON.parse(JSON.stringify(data.item));
            this.itemIdex = data.index;
            this.modalShow = true;
        },
        convertDate(value) {
            return this.$convert_date_string(value);
        },
        convertToMMYYYY(dateString) {
            if (dateString == null) return dateString;
            // Split the input string into day, month, and year components
            const [day, month, year] = dateString.split('/');

            // Create a new Date object using the components
            const dateObject = new Date(`${month}/01/${year}`);

            // Get month and year components from the Date object
            const convertedMonth = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const convertedYear = dateObject.getFullYear();

            // Return the formatted string
            return `${convertedMonth}-${convertedYear}`;
        },
        storeItem(bvModalEvt) {
            if (this.item.revenueFrom != null && this.item.revenueFrom != '') this.item.revenueFrom = Number(this.item.revenueFrom);
            else this.item.revenueFrom = 0;
            if (this.item.revenueTo != null && this.item.revenueTo != '') this.item.revenueTo = Number(this.item.revenueTo);
            else this.item.revenueTo = 0;

            if (this.item.grossFrom != null && this.item.grossFrom != '') this.item.grossFrom = Number(this.item.grossFrom);
            else this.item.grossFrom = 0;
            if (this.item.grossTo != null && this.item.grossTo != '') this.item.grossTo = Number(this.item.grossTo);
            else this.item.grossTo = 0;

            if (this.item.percent != null && this.item.percent != '') this.item.percent = Number(this.item.percent);
            else this.item.percent = 0;

            if (this.item.id <= 0) {

                axios
                    .post(this.url, this.item)
                    .then((res) => {
                        this.modalShow = false;
                        this.itemsOriginal.push(res.data);
                        this.onfilter();
                        this.$toast.success("Create Rate value successfully !", "Successful", {
                            timeout: 3000,
                        });
                    })
                    .catch((err) => {
                        this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
                    });
                // }

            } else {


                axios
                    .post(this.url, this.item)
                    .then((res) => {
                        this.modalShow = false;
                        this.items[this.itemIdex] = JSON.parse(
                            JSON.stringify(this.item)
                        );
                        var itemIdex = this.itemsOriginal.findIndex(item => item.id == this.item.id);
                        this.itemsOriginal[itemIdex] = JSON.parse(
                            JSON.stringify(this.item)
                        );
                        this.onfilter();
                        this.itemIdex = null;
                        this.$toast.success("Update Rate value successfully !", "Successful", {
                            timeout: 3000,
                        });
                    })
                    .catch((err) => {
                        this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
                    });


            }
        },
        deleteItem(data) {
            this.$toast.question("Do you really want to delete?", "Warning", {
                timeout: 20000,
                close: false,
                overlay: true,
                displayMode: "once",
                position: "center",
                buttons: [
                    [
                        "<button><b>Yes</b></button>",
                        (instance, toast) => {
                            axios
                                .delete(`/api/Bonus/delete?id=${data.item.id}`)
                                .then((res) => {
                                    this.items.splice(data.index, 1);
                                    this.$toast.success("Xóa thành công !", "Thành công", {
                                        timeout: 3000,
                                    });
                                })
                                .catch((err) => {
                                    this.$toast.error(err.response.data, "Lỗi", {
                                        timeout: 3000,
                                    });
                                });
                            instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                        },
                        true,
                    ],
                    [
                        "<button>No</button>",
                        function (instance, toast) {
                            instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                        },
                    ],
                ],
            });
        },
    },
};
</script>